var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleTranslate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6764 75.0058C73.505 75.0058 75.0029 73.5331 75.0029 71.73V38.3149C75.0029 36.5116 73.505 35.0389 71.6764 35.0389H39.2079L52.2383 75.0058H71.6764Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6764 36.5377C72.1622 36.5377 72.6232 36.728 72.969 37.0686C73.3096 37.4042 73.5 37.8449 73.5 38.3107V71.7192C73.5 72.185 73.3147 72.6257 72.969 72.9611C72.6234 73.3017 72.1624 73.492 71.6764 73.492H53.3306L41.277 36.5377H71.6764ZM71.6764 35.0353H39.2079L52.2383 74.9944H71.6764C73.505 74.9944 75.0029 73.522 75.0029 71.7192V38.3107C75.0029 36.5078 73.505 35.0353 71.6764 35.0353Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1608 65.5596L52.2367 75.0005L60.7878 65.5596H49.1608Z",
    fill: "#4352B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8959 48.8447V46.8864H62.453V43.7209H59.3871V46.8864H53.3607V48.8447H65.3535C64.7123 51.1035 63.2946 53.2371 61.9121 54.8949C59.4624 51.9949 59.4524 51.0534 59.4524 51.0534H56.9075C56.9075 51.0534 57.0128 52.4658 60.4493 56.4927C59.3321 57.6346 58.4855 58.3108 58.4855 58.3108L59.267 60.755C59.267 60.755 60.4493 59.7382 61.9271 58.1706C63.4098 59.7782 65.3235 61.7115 67.7982 64.0155L69.4062 62.4078C66.7561 60.0038 64.8125 58.0956 63.3848 56.5629C65.2983 54.2991 67.242 51.4492 67.6528 48.8397H71.8909V48.8447H71.8959Z",
    fill: "#607988"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3264 25C26.4979 25 25 26.4976 25 28.3307V62.2383C25 64.0664 26.4977 65.564 28.3264 65.564H60.7931L47.7634 25H28.3264Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6042 46.5669C43.4789 48.0844 42.1814 50.3332 39.0404 50.3332C36.3204 50.3332 34.1161 48.0844 34.1161 45.3148C34.1161 42.545 36.3204 40.2962 39.0404 40.2962C40.5884 40.2962 41.6204 40.9673 42.2114 41.5132L44.2753 39.5298C42.9178 38.2777 41.1494 37.4964 39.0403 37.4964C34.7272 37.4964 31.2255 40.9973 31.2255 45.3097C31.2255 49.6219 34.7272 53.123 39.0403 53.123C43.5589 53.123 46.5445 49.9526 46.5445 45.4801C46.5445 44.8389 46.4644 44.3682 46.3592 43.8874H39.0452V46.5619L43.6039 46.5669H43.6042Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleTranslate);
export default __webpack_public_path__ + "static/media/GoogleTranslate.763983269e301afe3903bd61b94dbf2f.svg";
export { ForwardRef as ReactComponent };